import React, { useEffect, useMemo, useState } from 'react'
import { DatePicker, Spin } from 'antd'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { getMyTeam } from 'src/store/ducks/my-team/actions'
import { PageHeader } from 'src/components/Ant'
import { useT } from 'src/core/hooks/use-translation'
import SegmentControlBase, { Segments } from 'src/components/SegmentControl'
import useDocumentTitle from 'src/hooks/use-document-title'

import Calendar from './components/Calendar'
import Map from './components/Map'
import { Container, ContainerSegmentControl, FilterContainer } from './styles'

type SegmentKeys = 'calendar' | 'map'

type MyTeamSegments = Segments<SegmentKeys>

export type RangeDate = [moment.Moment, moment.Moment]

function MyTeam() {
  const [currentSegment, setCurrentSegment] = useState<SegmentKeys>('calendar')
  const { t } = useT()

  const dispatch = useDispatch()
  const { myTeam } = useSelector((state: ApplicationState) => ({
    myTeam: state.myTeam
  }))

  const [dateRange, setDateRange] = useState<RangeDate>([
    moment(),
    moment().add(7, 'd')
  ])

  const segments = useMemo<MyTeamSegments>(() => {
    return {
      map: {
        disabled: false,
        title: 'web.my-team.segments.map',
        renderContent: () => <Map />
      },
      calendar: {
        disabled: false,
        title: 'web.my-team.segments.calendar',
        renderContent: () => <Calendar rangeDate={dateRange} />
      }
    }
  }, [dateRange])

  useDocumentTitle('web.my-team.title-page')
  useEffect(() => {
    dispatch(
      getMyTeam({
        filters: {
          started_on: dateRange[0].unix(),
          ended_on: dateRange[1].unix()
        }
      })
    )
  }, [dateRange, dispatch])

  return (
    <>
      <PageHeader title="web.my-team.title-page" />
      <ContainerSegmentControl>
        <SegmentControlBase
          defaultValue={currentSegment}
          onChange={({ target: { value } }) => setCurrentSegment(value)}
          segments={segments}
          value={currentSegment}
        />
      </ContainerSegmentControl>
      <Container bodyStyle={{ minHeight: '400px' }}>
        <FilterContainer>
          {myTeam.loading && <Spin />}
          <DatePicker.RangePicker
            defaultValue={dateRange}
            format="DD/MM/YYYY"
            onChange={range => {
              if (!!range[0] && !!range[1]) setDateRange([range[0], range[1]])
            }}
            placeholder={[t('common.startDate'), t('common.endDate')]}
          />
        </FilterContainer>
        {segments && segments[currentSegment].renderContent()}
      </Container>
    </>
  )
}

export default MyTeam
